import React, { Fragment } from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { Field, FieldProps, Form, Formik, FormikProps } from 'formik';
import {
  InputsWrapper,
  Wrapper,
} from '../../components/CheckPointEditor/styles';
import Input from '../../components/Input';
import notify from '../../components/Notify';
import { display } from 'components/ErrorView/ErrorDialog';
import messages from './messages';
import Button from '../../components/Button/Button';
import protectedRoute from '../../components/protectedRoute';
import { appDispatch } from 'store/store';
import { changeUserPhone, changeUserPhoneFn } from 'store/users/usersSlice';

type DispatchProps = {
  changePhone: (
    username: string,
    userId: string,
    currentPhone: string,
    newPhone: string,
    swapIfExists: boolean
  ) => ReturnType<typeof changeUserPhoneFn>;
};

type OwnProps = RouteComponentProps;

type ComponentProps = DispatchProps & OwnProps;
interface IFormValues {
  username: string;
  currentPhone: string;
  newPhone: string;
  userId: string;
  swapIfExists: boolean;
}
interface IComponentState {
  loading: boolean;
}

class ChangePhonePage extends React.PureComponent<
  ComponentProps,
  IComponentState
> {
  state = {
    loading: false,
  };
  onSubmitForm = (values: IFormValues) => {
    this.setState({ loading: true });
    this.props
      .changePhone(
        values.username,
        values.userId,
        values.currentPhone,
        values.newPhone,
        values.swapIfExists
      )
      .then(
        (response: string) => {
          notify(response === '2' ? messages.swapped : messages.changed);
          this.setState({ loading: false });
        },
        (e) => {
          display(e);
          this.setState({ loading: false });
        }
      );
  };

  render() {
    const initialValues: IFormValues = {
      username: '',
      currentPhone: '',
      newPhone: '',
      userId: '',
      swapIfExists: true,
    };

    const { loading } = this.state;
    return (
      <div>
        <Formik
          onSubmit={this.onSubmitForm}
          initialValues={initialValues}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {(formikBag: FormikProps<IFormValues>) => (
            // @ts-expect-error JSX error
            <Form>
              <Wrapper>
                <InputsWrapper>
                  <Field
                    name="username"
                    render={({ field }: FieldProps) => (
                      <Input
                        {...field}
                        type="text"
                        id="username"
                        required={true}
                        value={field.value}
                        label={messages.username}
                        placeholder={messages.username}
                      />
                    )}
                  />
                  <Field
                    name="userId"
                    render={({ field }: FieldProps) => (
                      <Input
                        {...field}
                        type="text"
                        id="userId"
                        value={field.value}
                        required={true}
                        label={messages.userId}
                        placeholder={messages.userId}
                      />
                    )}
                  />
                  <Field
                    name="currentPhone"
                    render={({ field }: FieldProps) => (
                      <Input
                        {...field}
                        type="text"
                        id="currentPhone"
                        required={true}
                        value={field.value}
                        label={messages.currentPhone}
                        placeholder={messages.currentPhone}
                      />
                    )}
                  />
                  <Field
                    name="newPhone"
                    render={({ field }: FieldProps) => (
                      <Input
                        {...field}
                        type="text"
                        id="false"
                        value={field.value}
                        required={true}
                        label={messages.newPhone}
                        placeholder={messages.newPhone}
                      />
                    )}
                  />
                  <Field
                    name="swapIfExists"
                    render={({ field }: FieldProps) => (
                      <Input
                        {...field}
                        type="checkbox"
                        id="swapIfExists"
                        checked={field.value}
                        required={false}
                        label={messages.swapIfExists}
                        placeholder={messages.swapIfExists}
                      />
                    )}
                  />
                </InputsWrapper>
                <Fragment>
                  <Button
                    color="green"
                    onClick={() => formikBag.handleSubmit()}
                    loading={loading}
                  >
                    {messages.submit}
                  </Button>
                </Fragment>
              </Wrapper>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = () => ({
  changePhone: (
    username: string,
    userId: string,
    currentPhone: string,
    newPhone: string,
    swapIfExists: boolean
  ) =>
    appDispatch(
      changeUserPhone({
        username,
        userId,
        currentPhone,
        newPhone,
        swapIfExists,
      })
    ),
});

export default protectedRoute(
  connect(undefined, mapDispatchToProps)(ChangePhonePage)
);
